import { Injectable } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { SapiService } from './sapi.service';
import { WebSocketsService } from './web-sockets.service';


@Injectable()
export class EntityStoreService {
	socketSubscription: Subscription;
	private store: any = {
		widget: {},
		mediaclip: {}
	};
	private subscriptions = new Subscription();

	constructor(
		private webSocketsService: WebSocketsService,
		private sapiService: SapiService
	) {
		this.subscriptions.add(this.sapiService.getSapiChanges().subscribe((sapiChange: any) => {
			if (!sapiChange || !sapiChange.entityName || !sapiChange.data || !sapiChange.data.length) {
				return;
			}

			sapiChange.data.forEach((entity: any) => {
				if (!entity) {
					return;
				}
				let valueProp = 'id';
				if (entity.type) {
					const mapping = this.getEntityMapping(entity.type);
					valueProp = mapping.value;
				}
				if (entity && entity[valueProp]) {
					switch (sapiChange.request) {
						default:
							this.setEntity(sapiChange.entityName, entity[valueProp], entity);
							break;
						case 'delete':
							this.removeEntity(sapiChange.entityName, entity[valueProp]);
							break;
					}
				}
			});
		}));
	}

	getEntityMapping(entityType: string) {
		if (typeof entityType === 'string') {
			entityType = entityType.toLowerCase();
		}
		let ret: any = {
			label: 'title',
			value: 'id'
		};
		switch (entityType) {
			default:
				ret = {
					label: 'title',
					value: 'id'
				};
				break;
			case 'datafeed':
				break;
			case 'placement':
			case 'lineup':
			case 'app':
			case 'project':
			case 'auction':
				ret = {
					label: 'name',
					value: 'id'
				};
				break;
			case 'playout':
				ret = {
					label: 'name',
					value: 'label'
				};
				break;
			case 'adunit':
			case 'lineitem':
				ret = {
					label: 'title',
					value: 'code'
				};
				break;
			case 'mediaclip':
			case 'commonclip':
				ret = {
					label: 'title',
					backupLabel: 'originalfilename',
					value: 'id'
				};
				break;
		}

		return ret;
	}

	enableSocketUpdates(entityType: 'MediaClip') {
		if (!this.socketSubscription) {
			this.socketSubscription = this.webSocketsService.subscribeToChannel(entityType).subscribe((websocketEvent: any) => {
				if (websocketEvent && websocketEvent.status === 'success' && websocketEvent.payload) {
					this.sapiService.sapiServiceSubject.next({request: 'websocket', entityName: entityType, data: [websocketEvent.payload]});
				}
			});
		}
	}

	removeEntity(entityName: string, id: string) {
		let valueProp = 'id';
		if (entityName) {
			const mapping = this.getEntityMapping(entityName);
			valueProp = mapping.value;
		}
		if (this.store[entityName] && this.store[entityName][valueProp]) {
			delete this.store[entityName][valueProp];
		}
	}

	getEntityAsync(entityName: string, valuePropValue: string) {
		const val = this.getEntity(entityName, valuePropValue);
		if (val) {
			return of(val);
		} else {
			return this.sapiService.get(entityName, valuePropValue);
		}
	}

	getEntity(entityName: string, valuePropValue: string) {
		// const val = this.store[entityName] && this.store[entityName][valuePropValue];
		return this.store[entityName] && this.store[entityName][valuePropValue];
	}

	setEntity(entityName: string, valuePropValue: string, entity: any) {
		// console.warn('[EntityStoreService] setEntity entityName', entityName, 'valueProp', valueProp, 'entity', entity);
		this.store[entityName] = this.store[entityName] || {};
		this.store[entityName][valuePropValue] = this.store[entityName][valuePropValue] ? {...this.store[entityName][valuePropValue], ...entity} : entity;
	}
}
